<script setup lang="ts">
// 1:1 port of the styleguide `kgr-modal-footer` — class carrier plus the shadow rule.
withDefaults(defineProps<{ showShadow?: boolean }>(), { showShadow: false });
</script>

<template>
    <div
        class="kgr-modal__footer kgr-region"
        :class="{ 'has-shadow': showShadow }"
    >
        <slot></slot>
    </div>
</template>

<style scoped>
.has-shadow {
    box-shadow: 0 -4px 5px -2px rgba(0, 0, 0, 0.2);
}
</style>
